import React from "react"
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap"
import "./CopyTrade.scss"
import { Sparklines, SparklinesLine } from 'react-sparklines';

import CopyTradeGrade from "../../assets/copyTrade/Images/Image_1.png"
import PieChart from "../../assets/copyTrade/Images/pie_chart.png"
import Trader from "../../assets/copyTrade/Icons/Icon_1.svg"
import TotalControl from "../../assets/copyTrade/Icons/Icon_2.svg"
import Performance from "../../assets/copyTrade/Icons/Icon_3.svg"
import Automation from "../../assets/copyTrade/Icons/Icon_4.svg"
import Flexible from "../../assets/copyTrade/Icons/Icon_5.svg"
import Rebates from "../../assets/copyTrade/Icons/Icon_6.svg"
import Payout from "../../assets/copyTrade/Icons/Icon_7.svg"
import Growth from "../../assets/copyTrade/Icons/Icon_8.svg"
import SmartPortfolios from "../../assets/copyTrade/Icons/Icon_9.svg"
import WebMobile from "../../assets/copyTrade/Icons/Icon_10.svg"
import Guru from "../../assets/copyTrade/Icons/Icon_11.svg"
import RiskControl from "../../assets/copyTrade/Icons/Icon_12.svg"
import Liquidity from "../../assets/copyTrade/Icons/Icon_13.svg"
import GlobalPool from "../../assets/copyTrade/Icons/Icon_14.svg"
import CheckCircle from '../../assets/fonts/feather/check-circle.svg';
import Avatar3 from '../../assets/images/avtar/3.jpg';
import Avatar4 from '../../assets/images/avtar/4.jpg';
import Avatar7 from '../../assets/images/avtar/7.jpg';
import Avatar11 from '../../assets/images/avtar/11.jpg';
import Avatar16 from '../../assets/images/avtar/16.jpg';

const CopyTrade = () => {

  // Default Data
  const chooseTradeHallCardList = [
    {
      icon: Automation,
      title: 'Seamless Automation',
      description: '',
      bulletPoint: [
        'One-click copying of proven strategies—trades execute automatically in your account.',
        "Example: @GoldSniper's 38% annual return replicated across 300+ follower accounts.",
      ],
      isCheckMark: false,
    },
    {
      icon: Trader,
      title: 'Elite Vetted Traders',
      description: 'AI-powered selection: Only 5% of applicants pass our:',
      bulletPoint: [
        '✔ 6-month minimum track record',
        '✔ Max 30% drawdown filter',
        '✔ Stress-testing during volatility events',
      ],
      isCheckMark: true,
    },
    {
      icon: TotalControl,
      title: 'Total Control',
      description: '',
      bulletPoint: [
        'Adjust lot sizes, risk limits, and stoploss rules per strategy.',
        'Pause/switch providers anytime—no lock-in periods.',
      ],
      isCheckMark: false,
    },
    {
      icon: Performance,
      title: 'Transparent Performance',
      description: 'Real-time access to:',
      bulletPoint: [
        '✔ Full historical trades',
        '✔ Risk-adjusted return metrics',
        '✔ Live drawdown alerts',
      ],
      isCheckMark: true,
    },
  ]

  const strategyProviderList = [
    {
      title: 'Performance Fees (20-50%)',
      description: 'Earn instantly when followers profit—no management fees during downturns.',
      points: [],
    },
    {
      title: 'Global Reach',
      description: 'Your strategy exposed to 18,000+ potential copiers worldwide.',
      points: [],
    },
    {
      title: 'Zero Operational Hassle',
      description: 'We handle:',
      points: ['✔ Automatic fee calculations & payouts', '✔ Marketing via "Top Traders Leaderboard"', '✔ Strategy privacy controls'],
    },
  ]

  const followerBenefitList = [
    {
      icon: SmartPortfolios,
      title: 'Automated Smart Portfolios:',
      description: 'AI-powered strategy blending combines top traders` signals into one balanced portfolio',
    },
    {
      icon: WebMobile,
      title: 'Web & Mobile Trading:',
      description: 'No downloads needed - execute trades directly from browser with real-time charts',
    },
    {
      icon: Guru,
      title: '50+ Verified Trading Gurus:',
      description: 'Choose from day traders, swing masters, and crypto specialists - all performance-verified',
    },
    {
      icon: RiskControl,
      title: 'Flexible Risk Control:',
      description: 'Adjust lot sizes, max drawdown limits, and asset allocation per strategy',
    },
    {
      icon: Liquidity,
      title: 'Instant Liquidity:',
      description: 'Withdraw your funds anytime - no lock-in periods like PAMM accounts',
    },
  ]

  const providerBenefitList = [
    {
      icon: Flexible,
      title: 'Flexible Monetization:',
      description: 'Choose profit-sharing (20-50%) or subscription fees - or combine both!',
    },
    {
      icon: GlobalPool,
      title: 'Global Investor Pool: ',
      description: 'Get instant exposure to 100+ potential copiers across 8 countries',
    },
    {
      icon: Rebates,
      title: 'Real-Time Rebates:',
      description: 'Earn your profit shares instantly when trades close - no monthly waiting periods',
    },
    {
      icon: Payout,
      title: 'Auto-Calculated Payouts:',
      description: 'Our system tracks and distributes fees automatically - zero manual work',
    },
    {
      icon: Growth,
      title: 'Performance-Based Growth:',
      description: 'Top performers get promoted on our Elite Traders Leaderboard (free marketing)',
    },
  ]

  const sevenDaysPnLTrendList = [
    {
      avatar: Avatar3,
      name: 'metric4counter',
      avgBal: '$12.2K',
      lastActivity: '3d ago',
      profitRate: '+20.7%',
      winRate: '83.3%',
      trendData: [5, 10, 8, 12, 15, 10, 18],
      volume: '$1.97M',
    },
    {
      avatar: Avatar4,
      name: 'cryptoD3x7',
      avgBal: '$7.1K',
      lastActivity: '2d ago',
      profitRate: '+21.2%',
      winRate: '70.9%',
      trendData: [8, 7, 9, 11, 13, 12, 14],
      volume: '$695.8K',
    },
    {
      avatar: Avatar7,
      name: 'neofliprofit',
      avgBal: '$5.8K',
      lastActivity: '1d ago',
      profitRate: '+19.7%',
      winRate: '71.6%',
      trendData: [10, 12, 11, 13, 15, 14, 16],
      volume: '$629.4K',
    },
    {
      avatar: Avatar11,
      name: 'diamondhand3',
      avgBal: '$1.8K',
      lastActivity: '9h ago',
      profitRate: '+23.4%',
      winRate: '81.2%',
      trendData: [7, 8, 10, 12, 11, 13, 15],
      volume: '$512.1K',
    },
    {
      avatar: Avatar16,
      name: '33trades.com',
      avgBal: '$4.0K',
      lastActivity: '18h ago',
      profitRate: '+19.6%',
      winRate: '69.7%',
      trendData: [6, 7, 8, 9, 10, 11, 12],
      volume: '$342.4K',
    },
    {
      avatar: Avatar4,
      name: 'sharpe3d',
      avgBal: '$5.1K',
      lastActivity: '5d ago',
      profitRate: '+20.9%',
      winRate: '88.4%',
      trendData: [9, 10, 11, 12, 13, 14, 15],
      volume: '$299.2K',
    },
    {
      avatar: Avatar3,
      name: 'x1pietrodes',
      avgBal: '$18.3K',
      lastActivity: '19h ago',
      profitRate: '+17.6%',
      winRate: '93.5%',
      trendData: [12, 13, 14, 15, 16, 17, 18],
      volume: '$231.2K',
    },
    {
      avatar: Avatar7,
      name: 'spartainwaves',
      avgBal: '$24.0K',
      lastActivity: '2d ago',
      profitRate: '+15.4%',
      winRate: '81.5%',
      trendData: [8, 9, 10, 11, 12, 13, 14],
      volume: '$865.7K',
    },
  ];

  return (
    <Container className="py-4" style={{ maxWidth: "1000px" }} >
      {/* Banner/Header */}
      <Card className="mb-4 border-0 rounded-4 shadow-sm banner-bg position-relative overflow-hidden">
        <CardBody
          className="p-4 p-md-5 position-relative d-flex flex-column justify-content-center align-items-center align-items-md-start"
          style={{ zIndex: 2 }}
        >
          <h2
            className="fw-bold text-white mb-4 text-center text-md-start"
            style={{
              fontSize: '1.25rem',
              lineHeight: 1.2,
            }}
          >
            <span
              className="d-flex"
              style={{
                fontSize: 'clamp(1.75rem, 5vw, 40px)',
                fontWeight: 700,
                fontStyle: 'italic',
              }}
            >
              Tradehall Copy Trading:
            </span>
            <span
              className="d-flex"
              style={{
                fontSize: 'clamp(1.25rem, 4vw, 32px)',
                fontWeight: 400,
              }}
            >
              Effortless Investing, Expert Results
            </span>
          </h2>

          <div
            className="text-white mb-2 text-start"
            style={{
              fontSize: 'clamp(1rem, 3.5vw, 24px)',
              lineHeight: 1.4,
            }}
          >
            Let the world's top traders work for you—
            <br className="d-none d-md-block" />
            zero experience needed!
          </div>
        </CardBody>
      </Card>

      {/* Institutional-Grade Copy Trading - REVISED UI */}
      <Card
        className="mb-4 border-0 rounded-4 shadow-sm p-0 position-relative overflow-hidden"
        style={{ background: '#fff' }}
      >
        {/* Row: Left text + Right image */}
        <Row className="g-0 align-items-center p-4 pb-0">
          <Col xs={12} md={7} className="mb-3 mb-md-0">
            <h4 className="fw-bold mb-2" style={{ fontSize: '2rem', lineHeight: 1.2 }}>
              Institutional-Grade Copy Trading<br />
              for Retail Investors
            </h4>
            <ul className="ps-0 mb-0" style={{ listStyle: 'none', fontSize: '1.125rem' }}>
              <li className="mb-2 d-flex align-items-center">
                <img src={CheckCircle} alt="check" width={22} className="me-2" />
                AI-Vetted Strategies
              </li>
              <li className="mb-2 d-flex align-items-center">
                <img src={CheckCircle} alt="check" width={22} className="me-2" />
                Real-Time Risk Control
              </li>
              <li className="d-flex align-items-center">
                <img src={CheckCircle} alt="check" width={22} className="me-2" />
                20–50% Profit Sharing
              </li>
            </ul>
          </Col>
          <Col xs={12} md={5} className="d-flex align-items-center justify-content-end p-0">
            <img
              src={CopyTradeGrade}
              alt="Institutional Copy Trading"
              style={{ maxWidth: '100%', maxHeight: 180, objectFit: 'contain', zIndex: 1, marginRight: 0 }}
            />
          </Col>
        </Row>
        <Row className="g-0 px-4">
          <Col xs={12}>
            <div className="table-responsive mb-0">
              <table className="table align-middle mb-0" style={{ minWidth: 420 }}>
                <thead style={{ borderTop: '1px solid rgba(0,0,0,0.2)', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                  <tr style={{ background: 'transparent' }}>
                    <th style={{ fontSize: '12px', border: 'none', whiteSpace: 'nowrap' }}>Signal Provider</th>
                    <th style={{ fontSize: '12px', border: 'none', whiteSpace: 'nowrap' }}>Avg Buy</th>
                    <th style={{ fontSize: '12px', border: 'none', whiteSpace: 'nowrap' }}>Last Activity</th>
                    <th style={{ fontSize: '12px', border: 'none', whiteSpace: 'nowrap' }}>7d Profit Rate</th>
                    <th style={{ fontSize: '12px', border: 'none', whiteSpace: 'nowrap' }}>7d Win Rate</th>
                    <th style={{ fontSize: '12px', border: 'none', whiteSpace: 'nowrap' }}>7d PnL Trend</th>
                    <th style={{ fontSize: '12px', border: 'none', whiteSpace: 'nowrap' }}>Volume</th>
                    <th style={{ border: 'none' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {sevenDaysPnLTrendList.map((row, idx) => (
                    <tr key={idx} style={{ border: 'none', background: 'transparent' }}>
                      <td style={{ border: 'none' }}>
                        <div className="d-flex align-items-center gap-2">
                          <img className="mr-2" src={row.avatar} alt={row.name} width={32} height={32} style={{ borderRadius: '50%', objectFit: 'cover' }} />
                          <span style={{ fontWeight: 500 }}>{row.name}</span>
                        </div>
                      </td>
                      <td style={{ border: 'none' }}>{row.avgBal}</td>
                      <td style={{ border: 'none' }}>{row.lastActivity}</td>
                      <td style={{ border: 'none', color: '#1dbf73', fontWeight: 600 }}>{row.profitRate}</td>
                      <td style={{ border: 'none' }}>{row.winRate}</td>
                      <td style={{ border: 'none', minWidth: 56 }}>
                        <Sparklines data={row.trendData} width={56} height={16} margin={2}>
                          <SparklinesLine color="#1dbf73" style={{ strokeWidth: 2, fill: "none" }} />
                        </Sparklines>
                      </td>
                      <td style={{ border: 'none', fontWeight: 500 }}>{row.volume}</td>
                      <td style={{ border: 'none' }}>
                        <Button
                          href="https://copytrade-signal.tradehallgroup.co:8081/widgets/ratings?widgetKey=social_platform_ratings"
                          target="_blank"
                          rel="noopener noreferrer"
                          color="primary" className="rounded-pill px-3 py-1 fw-bold" style={{ color: '#222', fontWeight: 600, fontSize: '1rem', background: '#FFD600', border: 'none' }}>
                          Follow
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
        <Row className="g-0 py-4">
          <Col xs={12} className="d-flex justify-content-center">
            <Button
              href='https://copytrade-signal.tradehallgroup.co:8081/widgets/ratings?widgetKey=social_platform_ratings'
              target='_blank'
              rel="noopener noreferrer"
              color="primary"
              className="rounded-pill fw-bold px-4 py-2 explore-strategies-btn"
              style={{
                color: 'black',
                fontSize: '1.1rem',
                fontWeight: '700',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                transition: 'all 0.3s ease-in-out',
                transform: 'scale(1)'
              }}
            >
              Explore Elite Strategies Now
            </Button>
          </Col>
        </Row>
        <Row className="g-0 p-4">
          <Col className="d-flex justify-content-center">
            <img
              src={PieChart}
              alt="PieChart"
              style={{ maxWidth: '100%', maxHeight: 482, objectFit: 'contain', zIndex: 1 }}
            />
          </Col>
        </Row>
      </Card>

      {/* Why Smart Investors Choose... */}
      <Card className="mb-4 border-0 rounded-4 shadow-sm p-3" style={{ background: '#fafbfc' }}>
        <CardBody className="p-0">
          <h5 className="fw-bold mb-3" style={{ fontSize: '24px' }}>Why Smart Investors Choose Tradehall Copy Trading</h5>
          <Row className="gy-3 gx-3">
            {
              chooseTradeHallCardList.map((item, index) => (
                <Col key={index} xs={12} sm={6} style={{ marginBottom: '28px' }}>
                  <Card className="h-100 border-0 rounded-3 p-4 shadow-none" style={{ backgroundColor: '#F1F1F1' }}>
                    <div className="d-flex align-items-start mb-2"><img src={item.icon} alt={item.title} width={60} className="me-2" /></div>
                    <div className="fw-bold my-4" style={{ fontSize: '22px', fontWeight: '600' }}>{item.title}</div>
                    <ul className="ps-3 mb-0" style={{ fontSize: '16px', listStyleType: item.isCheckMark ? 'none' : 'disc', marginLeft: item.isCheckMark ? '0' : '19px' }}>
                      {
                        item.bulletPoint.map((point, pointIndex) => (
                          <li key={pointIndex}>{point}</li>
                        ))
                      }
                    </ul>
                  </Card>
                </Col>
              ))
            }
          </Row>
        </CardBody>
      </Card>

      {/* For Strategy Providers */}
      <Card className="mb-4 border-0 rounded-4 shadow-sm p-3" style={{ background: '#fafbfc' }}>
        <CardBody className="p-0">
          <h5 className="fw-bold mb-3" style={{ fontSize: '24px' }}>For Strategy Providers: Monetize Your Edge</h5>
          <Row className="gy-3 gx-3">
            {
              strategyProviderList.map((item, index) => (
                <Col key={index} xs={12} sm={4} className='mb-2'>
                  <Card className="h-100 border rounded-3 p-3">
                    <div className="fw-bold mb-4" style={{ fontWeight: '600', fontSize: '18px' }}>{item.title}</div>
                    <div style={{ fontSize: '0.97rem', lineHeight: '1.2' }}>{item.description}</div>
                    {
                      item.points.length > 0 &&
                      <ul className="ps-3 mb-0" style={{ fontSize: '0.97rem' }}>
                        {
                          item.points.map((point, pointIndex) => (
                            <li key={pointIndex}>{point}</li>
                          ))
                        }
                      </ul>
                    }
                  </Card>
                </Col>
              ))
            }
          </Row>
        </CardBody>
      </Card>

      {/* Benefits for Followers & Signal Providers */}
      <Row className="gy-4 gx-4 mb-4">
        <Col xs={12} md={6}>
          <Card className="border-0 rounded-4 shadow-sm p-3 h-100">
            <CardBody className="p-0 d-flex flex-column h-100">
              <h5 className="fw-bold mb-3">Benefits for Followers</h5>
              <div className="mb-3">
                {
                  followerBenefitList.map((item, index) => (
                    <div key={index} className="d-flex align-items-start gap-3 border-bottom pb-3 mb-3">
                      <img className="m-2" src={item.icon} alt={item.title} width={38} />
                      <div>
                        <div className="fw-bold">{item.title}</div>
                        <div className="text-muted small">{item.description}</div>
                      </div>
                    </div>
                  ))
                }
              </div>
              <div className="mb-3 text-muted small">Sleep while the world's best traders work for you!</div>
              <Button href='https://copytrade.tradehallgroup.co:8080/' target='_blank' rel="noopener noreferrer" color="primary" className="w-100 rounded-pill fw-bold py-2 mt-auto" style={{ fontSize: "1.08rem", color: 'black', fontWeight: '600' }}>
                Start Copying Now
              </Button>
            </CardBody>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card className="border-0 rounded-4 shadow-sm p-3 h-100">
            <CardBody className="p-0 d-flex flex-column h-100">
              <h5 className="fw-bold mb-3">Benefits for Signal Providers</h5>
              <div className="mb-3">
                {
                  providerBenefitList.map((item, index) => (
                    <div key={index} className="d-flex align-items-start gap-3 border-bottom pb-3 mb-3">
                      <img className="m-2" src={item.icon} alt={item.title} width={38} />
                      <div>
                        <div className="fw-bold">{item.title}</div>
                        <div className="text-muted small">{item.description}</div>
                      </div>
                    </div>
                  ))
                }
              </div>
              <div className="mb-3 text-muted small">Get paid for trades you'd make anyway – now with 100x the earning power!</div>
              <Button href='https://copytrade.tradehallgroup.co:8080/portal/registration/provider?redirectUrl=%2F' target='_blank' rel="noopener noreferrer" color="primary" className="w-100 rounded-pill fw-bold py-2 mt-auto" style={{ fontSize: "1.08rem", color: 'black', fontWeight: '600' }}>
                Become a Provider
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default CopyTrade